import { HighlightType } from '@node-space/ui-components'
import {
  CustomerDocumentStatus,
  CustomerDocumentStatusType,
  CustomerEntityType,
} from 'types/customers'
import { EMBEDDED_CUSTOMER_STATUSES } from './constants'
import { EmbeddedCustomerStatus } from './types'

export const customerTypeLabel: Record<CustomerEntityType, string> = {
  [CustomerEntityType.COMPANY]: 'business',
  [CustomerEntityType.INDIVIDUAL]: 'individual',
}

export const customerTypeHighlight: Partial<Record<CustomerEntityType, HighlightType>> = {
  [CustomerEntityType.INDIVIDUAL]: 'feature',
}

export const customerStatusLabel: Record<EmbeddedCustomerStatus, string> = {
  [EMBEDDED_CUSTOMER_STATUSES.PENDING_AGREEMENTS]: 'pendingAgreements',
  [EMBEDDED_CUSTOMER_STATUSES.INFO_REQUIRED]: 'infoRequired',
  [EMBEDDED_CUSTOMER_STATUSES.PENDING]: 'pending',
  [EMBEDDED_CUSTOMER_STATUSES.REJECTED]: 'rejected',
  [EMBEDDED_CUSTOMER_STATUSES.VERIFIED]: 'verified',
  [EMBEDDED_CUSTOMER_STATUSES.TERMINATED]: 'terminated',
}

export const customerStatusHighlight: Partial<Record<EmbeddedCustomerStatus, HighlightType>> = {
  [EMBEDDED_CUSTOMER_STATUSES.PENDING_AGREEMENTS]: 'warning',
  [EMBEDDED_CUSTOMER_STATUSES.INFO_REQUIRED]: 'warning',
  [EMBEDDED_CUSTOMER_STATUSES.REJECTED]: 'error',
  [EMBEDDED_CUSTOMER_STATUSES.VERIFIED]: 'success',
  [EMBEDDED_CUSTOMER_STATUSES.TERMINATED]: 'error',
}

export const customerDocumentStatusHighlight: Partial<
  Record<CustomerDocumentStatusType, HighlightType>
> = {
  [CustomerDocumentStatus.PENDING]: 'warning',
  [CustomerDocumentStatus.INT]: 'warning',
  [CustomerDocumentStatus.APPROVED]: 'success',
  [CustomerDocumentStatus.INFO_REQUIRED]: 'warning',
  [CustomerDocumentStatus.DECLINE]: 'error',
  [CustomerDocumentStatus.REJECTED]: 'error',
}

export const customerDocumentStatusLabel: Record<CustomerDocumentStatusType, string> = {
  [CustomerDocumentStatus.PENDING]: 'pending',
  [CustomerDocumentStatus.INFO_REQUIRED]: 'infoRequired',
  [CustomerDocumentStatus.INT]: 'rejected',
  [CustomerDocumentStatus.APPROVED]: 'verified',
  [CustomerDocumentStatus.DECLINE]: 'declined',
  [CustomerDocumentStatus.REJECTED]: 'rejected',
}
